module.exports = __webpack_public_path__ + "img/fig29.56adbc09.jpg";